import { get, post } from "./common";
// import config from "../config";
import { MyThunkAction } from "../types";
import { ON_PAGINATION_LIST_LOADING, ON_PAGINATION_LIST_RESPONSE } from "./PaginationActions";
import { sendAlert } from "./UserAction";



export const ON_LOGS_LIST_LOAD = "ON_LOGS_LIST_LOAD";
export const GET_API_DETAILS = "GET_API_DETAILS";
export const GET_MEAT_DATA = "GET_MEAT_DATA";
export const CLEAR_API_DETAILS ="CLEAR_API_DETAILS"
export const ON_LOGS_LOADING_START = "ON_LOGS_LOADING_START";
export const ON_LOGS_LOADING_FINISHED = "ON_LOGS_LOADING_FINISHED";
export const ON_LOADING_START = "ON_LOADING_START";
export const ON_LOADING_FINISHED = "ON_LOADING_FINISHED";
export const SET_QUERY_DATA = "SET_QUERY_DATA";
export const SET_CURRENT_REQUEST_ID = "SET_CURRENT_REQUEST_ID";


export const GET_MENU_LIST_LOADING = "GET_MENU_LIST_LOADING";
export const GET_MENU_LIST_SUCCESS = "GET_MENU_LIST_SUCCESS";

export const LOGS_EXPORT_LOADING_START = "LOGS_EXPORT_LOADING_START";
export const LOGS_EXPORT_LOADING_FINISHED = "LOGS_EXPORT_LOADING_FINISHED";


export const clearApiData = () => ({
  type: CLEAR_API_DETAILS,
});

export const setQueryData = (queryString?:any, forceReset?:boolean) => ({
  type:SET_QUERY_DATA,
  payload: queryString
});

export const getLogsListing = (queryString?:any, forceReset?:boolean, isRefreshing?: boolean, requestId?: number): MyThunkAction => async (dispatch: any, getState: any) => {  

  try {
    const response = await post(`/metrics/list`, queryString);


    if (requestId) {
      const state = getState();
      const currentRequestId = state.logs.currentRequestId || 0;
      
      if (requestId < currentRequestId) {
        return { status: 'outdated' };
      }
      
      dispatch({
        type: SET_CURRENT_REQUEST_ID,
        payload: requestId
      });
    }

    
    if(response?.error){
      dispatch({ type: ON_LOGS_LOADING_START, payload:false });
      const errorMsg = response?.error?.response?.data?.error;
      dispatch( sendAlert({
        text: errorMsg,
        snack: true,
        snackTimeout: 4000,
        snackType: "error",
      }));
    } else {
      dispatch({
        type: ON_LOGS_LIST_LOAD,
        payload: {
          forceReset,
          queryString: queryString,
          response: response
        },
      });
      
      if (isRefreshing) {
        dispatch({ type: ON_LOGS_LOADING_FINISHED, payload:false });
      }
      
      return { logs:response, status: 200 };
    }
  } catch (error: any) {
    dispatch({ type: ON_LOGS_LOADING_START, payload:false });
    const errorMsg = error?.error?.response?.data?.error || 'An unexpected error occurred';
    dispatch( sendAlert({
     text: errorMsg,
     snack: true,
     snackTimeout: 4000,
     snackType: "error",
    }));
  }
};

export const getApiDetails = (queryString?:any, forceReset?:boolean): MyThunkAction => async (dispatch: any) => {

  dispatch({ type: ON_LOADING_START, payload:true });

  const response = await post(`/metrics/action`,queryString)

  dispatch({
    forceReset,
    type: GET_API_DETAILS,
    payload: {forceReset,response:response},
  });
  dispatch({ type: ON_LOADING_FINISHED, payload:false });
  return { status: 200 };
};


export const getmetaData = (queryString?:any): MyThunkAction => async (dispatch: any) => {

  const response = await post(`/metrics/metadata`,queryString)

  dispatch({
    type: GET_MEAT_DATA,
    payload: response,
  });
  return { status: 200 };
};


export const getMenuList = (path: string): MyThunkAction => async (dispatch: any) => {  
  dispatch({ type: `${GET_MENU_LIST_LOADING}` });

  const response = await get(`metrics/action/menu/download?path=${path}`);

  if (response?.error) {
    const errorMsg = response?.error?.response?.data?.error;
    sendAlert({
      text: errorMsg || "An unexpected error occurred.",
      snack: true,
      snackTimeout: 4000,
      snackType: "error",
    });
    return { status: 400 };
  }

  return response;
};

export const getLogsExport = (queryString: any): MyThunkAction => async (dispatch: any) => {  
  dispatch({ type: LOGS_EXPORT_LOADING_START });
  const startTime = Date.now();
  const response = await post(`/metrics/list/export`, queryString);
  const elapsed = Date.now() - startTime;

  if (response?.error) {
    const status = response?.error?.response?.status;
    const isTimeout = elapsed > 30000;
    const isCancelled = response?.error?.code === 'ECONNABORTED' || response?.error?.message?.includes('timeout');
    
    if ((status === 500 && isTimeout) || isCancelled) {
      dispatch(sendAlert({
        text: "Request timed out. Please adjust your filters and try again.",
        snack: true,
        snackTimeout: 4000,
        snackType: "error",
      }));
    } else {
      const errorMsg = response?.error?.response?.data?.error;
      dispatch(sendAlert({
        text: errorMsg,
        snack: true,
        snackTimeout: 4000,
        snackType: "error",
      }));
    }
    dispatch({ type: LOGS_EXPORT_LOADING_FINISHED });
    return { status: 400 };
  } else {
    dispatch({ type: LOGS_EXPORT_LOADING_FINISHED });
    return response;
  }
};

export const downloadPayload = (path: string): MyThunkAction<Promise<{url?: string, status: number}>> => async (dispatch: any) => {  
  try {
    const response = await get(`/metrics/action/payload/download?path=${path}`);
    
    if (response?.error) {
      const errorMsg = response?.error?.response?.data?.error;
      dispatch(sendAlert({
        text: errorMsg || "Failed to download payload",
        snack: true,
        snackTimeout: 4000,
        snackType: "error",
      }));
      return { status: 400 };
    }
    
    return response;
  } catch (error) {
    dispatch(sendAlert({
      text: "An error occurred while downloading payload",
      snack: true,
      snackTimeout: 4000,
      snackType: "error",
    }));
    return { status: 500 };
  }
};